"use strict";

import React from "react";
import cx from "classnames";

function PanelContent(props) {
  const { baseClassName, className, children, ...other } = props;

  return (
    <div className={cx(baseClassName, className)} {...other}>
      {children}
    </div>
  );
}

PanelContent.defaultProps = {
  baseClassName: "si-c-panel__content",
};

export default PanelContent;
